module.exports = __webpack_public_path__ + "static/media/bg.people.meeting.344682e8.png";